export default __webpack_public_path__ + "static/media/bannerImgRedirect.a3e48d34.png";